import script from "./AiChatBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiChatBanner.vue?vue&type=script&setup=true&lang=ts"

import "./AiChatBanner.vue?vue&type=style&index=0&id=e8ae1e7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8ae1e7e"]])

export default __exports__